import React, { useState, useEffect, useCallback } from 'react';
import { Center, Spinner } from '@chakra-ui/react';

export const useLoading = () => {
  const [loading, setLoading] = useState(false);
  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);

  const startLoading = useCallback(() => {
    if (isMounted) {
      setLoading(true);
    }
  }, [isMounted]);

  const stopLoading = useCallback(() => {
    if (isMounted) {
      setLoading(false);
    }
  }, [isMounted]);

  const LoadingSpinner = useCallback(() => {
    if (!loading) return null;

    return (
      <Center
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg="rgba(255, 255, 255, 0.7)"
        backdropFilter="blur(4px)"
        zIndex="1"
      >
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="brand.primary"
          size="xl"
        />
      </Center>
    );
  }, [loading]);

  return { loading, startLoading, stopLoading, LoadingSpinner };
};
